import { useState } from 'react';
import { Link } from 'react-router-dom';
import { NavItem } from '../../../helpers';
import MenuButton from './MenuButton';

interface DesktopNavProps {
  items: NavItem[];
  onMenuOpenChange: (open: boolean) => void;
}

const NAV_LINK_CLASS =
  'text-sm font-semibold text-inherit transition-opacity hover:opacity-80 focus-visible:outline-2 focus-visible:outline-white focus-visible:outline-offset-2 rounded-sm';
const NAV_CTA_CLASS =
  'bg-secondary hover:bg-secondary-hover text-secondary-foreground text-sm font-semibold px-5 py-2.5 rounded-md transition-colors focus-visible:outline-2 focus-visible:outline-white focus-visible:outline-offset-2';

const DesktopNav = ({ items, onMenuOpenChange }: DesktopNavProps) => {
  const [, setOpenCount] = useState(0);

  const handleItemOpenChange = (isOpen: boolean) => {
    setOpenCount(prev => {
      const next = isOpen ? prev + 1 : Math.max(0, prev - 1);
      onMenuOpenChange(next > 0);
      return next;
    });
  };

  return (
    <nav className="hidden lg:flex items-center gap-7">
      {items.map(item =>
        item.type === 'dropdown' ? (
          <MenuButton
            key={item.label}
            label={item.label}
            options={item.options}
            onOpenChange={handleItemOpenChange}
          />
        ) : (
          <Link
            key={item.label}
            to={item.to}
            className={item.isCta ? NAV_CTA_CLASS : NAV_LINK_CLASS}
          >
            {item.label}
          </Link>
        ),
      )}
    </nav>
  );
};

export default DesktopNav;
